{{ctx.element}}
<div
  class="signature-pad-body"
  tabindex="{{ctx.component.tabindex || 0}}"
  ref="padBody"
>
  <button
    type="button"
    class="btn btn-sm btn-light signature-pad-refresh utrecht-button utrecht-button--html-button utrecht-button--subtle"
    ref="refresh"
  >
    <i class="{{ctx.iconClass('refresh')}}">
      <!-- For accessibility a Button element must contain text content -->
      <span class="sr-only">{{ctx.t('Refresh')}}</span>
    </i>
  </button>
  <canvas class="signature-pad-canvas" height="{{ctx.component.height}}" ref="canvas"></canvas>
  {% if (ctx.required) { %}
  <span class="form-control-feedback field-required-inline text-danger">
    <i class="{{ctx.iconClass('asterisk')}}"></i>
  </span>
  {% } %}
  <img ref="signatureImage" class="signature-pad-body__image" />
</div>
{% if (ctx.component.footer) { %}
<div class="signature-pad-footer">
  {{ctx.t(ctx.component.footer, {_userInput: true})}}
</div>
{% } %}
